import React, {useMemo} from "react";
import {AllocatedAssetCostSummary} from "../../../../domains/models/asset-management";
import {
    Cell,
    Legend,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip
} from "recharts";

interface CostPieChartProps {
    summary: AllocatedAssetCostSummary;
}

const CostPieChart = ({summary}: CostPieChartProps) => {

    const PIE_COLORS = [
        'var(--asset-allocated)',
        'var(--asset-available)',
        'var(--asset-disposed)',
        'var(--asset-missing)',
        'var(--asset-under-maintenance)',
    ];

    const chartData = useMemo(() => {
        if (!summary) return [];

        return [
            {
                name: "Allocated",
                value: summary.allocated,
                percentage: summary.allocatedPercentage
            },
            {
                name: "Available",
                value: summary.available,
                percentage: summary.availablePercentage
            },
            {
                name: "Disposed",
                value: summary.disposed,
                percentage: summary.disposedPercentage
            },
            {
                name: "Missing",
                value: summary.missed,
                percentage: summary.missedPercentage
            },
            {
                name: "Under Maintenance",
                value: summary.underMaintenance,
                percentage: summary.underMaintenancePercentage
            },
        ];
    }, [summary]);

    return (
        <section className="pn-asset__card">
            <div className="pn-asset__card__header">
                <div>
                    <h3 className="pn-asset__card__title">Cost Distribution</h3>
                </div>
            </div>

            <ResponsiveContainer width="100%" height={260}>
                <PieChart>
                    <Pie
                        data={chartData}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={80}
                        paddingAngle={3}
                        dataKey="value"
                        nameKey="name"
                        stroke="none"
                    >
                        {chartData.map((_, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={PIE_COLORS[index % PIE_COLORS.length]}
                            />
                        ))}
                    </Pie>

                    <Tooltip
                        contentStyle={{
                            background: '#FFFFFF',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            fontSize: '12px',
                            fontWeight: 600,
                            color: '#0f172a',
                        }}

                        formatter={(value, name, props) => {
                            const percentage = props.payload.percentage;
                            return [
                                percentage
                                    ? `₹ ${value} (${percentage}%)`
                                    : value,
                                name
                            ];
                        }}
                    />

                    <Legend
                        iconType="circle"
                        iconSize={8}
                        wrapperStyle={{
                            fontSize: '12px',
                            color: '#64748b'
                        }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </section>
    );
};

export default CostPieChart;